var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ContainerType } from "@/models/Container";
import Item, { ColourGroup, LaundryCategory, PackingCategory } from "@/models/Item";
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from "vue-property-decorator";
import BootstrapVue from 'bootstrap-vue';
import * as Ladda from 'ladda';
Vue.use(BootstrapVue);
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'ladda/dist/ladda-themeless.min.css';
var ItemComponent = /** @class */ (function (_super) {
    __extends(ItemComponent, _super);
    function ItemComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.currentItem = new Item('');
        _this.error = '';
        _this.colorGroup = ColourGroup;
        _this.laundryCategory = LaundryCategory;
        _this.packingCategory = PackingCategory;
        _this.updated = false;
        _this.loading = true;
        _this.imagePreview = null;
        return _this;
    }
    Object.defineProperty(ItemComponent.prototype, "formTitle", {
        get: function () {
            return this.currentItem.name.length ? this.currentItem.name : 'Dodaj nowy przedmiot';
        },
        enumerable: true,
        configurable: true
    });
    ItemComponent.prototype.onCurrentItemChange = function (item) {
        this.imagePreview = item.image;
    };
    ItemComponent.prototype.created = function () {
        return __awaiter(this, void 0, void 0, function () {
            var doc;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.id) return [3 /*break*/, 2];
                        this.loading = true;
                        return [4 /*yield*/, this.$dao.getItemById(this.id, this.container)];
                    case 1:
                        doc = _a.sent();
                        if (doc) {
                            this.currentItem = doc;
                        }
                        _a.label = 2;
                    case 2:
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    ItemComponent.prototype.addItem = function () {
        var _this = this;
        this.$validator.validateAll().then(function (result) {
            if (result) {
                _this._addItem();
            }
        }).catch(function () {
            return false;
        });
    };
    ItemComponent.prototype._addItem = function () {
        var _this = this;
        var l = null;
        var btn = this.$refs.saveBtn;
        if (btn instanceof HTMLButtonElement) {
            l = Ladda.create(btn);
        }
        if (!this.currentItem.idContainer) {
            var defaultContainer = this.$store.state.containers.list.find(function (el) { return el.type == ContainerType.Default; });
            if (defaultContainer) {
                this.currentItem.idContainer = defaultContainer.id;
            }
        }
        if (l) {
            l.start();
        }
        this.$dao.saveItem(this.currentItem).then(function (doc) {
            if (l) {
                l.stop();
            }
            if (doc) {
                _this.$router.push({ name: 'item', params: { id: doc.id, container: _this.currentItem.idContainer, saved: "1" } });
            }
            else {
                _this.updated = true;
            }
        });
    };
    ItemComponent.prototype.setImage = function (input) {
        var _this = this;
        // Ensure that you have a file before attempting to read it
        if (input.files && input.files[0]) {
            // create a new FileReader to read this image and convert to base64 format
            var reader = new FileReader();
            // Define a callback function to run, when FileReader finishes its job
            reader.onload = function (e) {
                _this.imagePreview = e.target.result;
            };
            // Start the reader job - read file as a data url (base64 format)
            reader.readAsDataURL(input.files[0]);
            //save file input to model
            this.currentItem.image = input.files[0];
        }
    };
    ItemComponent.prototype.getUrl = function (container) {
        return { name: 'container', params: { id: container.id } };
    };
    ItemComponent.prototype.cancel = function () {
        var defaultContainer = this.$store.state.containers.list.filter(function (el) { return el.type == ContainerType.Default; });
        if (defaultContainer.length) {
            this.$router.replace(this.getUrl(defaultContainer.pop()));
        }
    };
    __decorate([
        Prop()
    ], ItemComponent.prototype, "id", void 0);
    __decorate([
        Prop()
    ], ItemComponent.prototype, "container", void 0);
    __decorate([
        Prop()
    ], ItemComponent.prototype, "saved", void 0);
    __decorate([
        Watch('currentItem')
    ], ItemComponent.prototype, "onCurrentItemChange", null);
    ItemComponent = __decorate([
        Component
    ], ItemComponent);
    return ItemComponent;
}(Vue));
export default ItemComponent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./src/components/item/component.ts
// module id = null
// module chunks = 